import * as React from 'react';

import { ViewMedium, Viewport, ViewSmall } from '@shared-ui/viewport-context';

import { PriceSummary } from 'models';

import { PriceBreakDownDetails } from './price-breakdown-details';
import { PriceBreakDownDialog } from './price-breakdown-dialog';
import { PriceBreakDownMenu } from './price-breakdown-menu';

export interface ChildActionsOptions {
  trackingRfrr?: string;
  className?: string;
}

export interface PriceBreakDownProps {
  lodgingPriceBreakDown?: PriceSummary;
  id?: string;
  roomName?: string;
  layerId: string | number;
  childActions?: (options: ChildActionsOptions) => React.ReactNode;
}

export const PriceBreakDown: React.FunctionComponent<PriceBreakDownProps> = props => {
  const { lodgingPriceBreakDown, id, roomName, layerId, childActions } = props;

  if (!lodgingPriceBreakDown) {
    return null;
  }

  const header = lodgingPriceBreakDown?.priceSummaryHeading?.value;

  const commonPriceBreakdownProps = {
    id,
    header,
    layerId,
    roomName,
  };

  const commonPriceBreakDownContentProps = {
    lodgingPriceBreakDown,
    roomName,
    layerId,
  };

  const childActionDialog = typeof childActions === 'function' ? childActions({ trackingRfrr: 'PriceDetailDialog' }) : null;
  const childActionMenu = typeof childActions === 'function' ? childActions({ trackingRfrr: 'PriceDetailMenu' }) : null;
  const breakdownMenuChildContent = (
    <PriceBreakDownDetails {...commonPriceBreakDownContentProps} childActions={childActionMenu} shouldDisplayHeader={true} />
  );

  return (
    <>
      {lodgingPriceBreakDown && (
        <Viewport>
          <ViewSmall>
            <PriceBreakDownDialog
              {...commonPriceBreakdownProps}
              childContent={<PriceBreakDownDetails {...commonPriceBreakDownContentProps} childActions={childActionDialog} />}
            />
          </ViewSmall>
          <ViewMedium>
            <PriceBreakDownMenu {...commonPriceBreakdownProps} childContent={breakdownMenuChildContent} />
          </ViewMedium>
        </Viewport>
      )}
    </>
  );
};
